import React, { Component } from 'react';
import { Helmet } from 'react-helmet'; 
import PropTypes from 'prop-types';

class Meta extends Component {
    
    constructor(props) {
        super(props);
    }

    escapeWords(string) {
        if(typeof string !== 'string') {
          return string;
        }
        return string.replace(/[&'`"<>]/g, function(match) {
          return {
            '&': '&amp;',
            "'": '&#39;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;',
            '%': '&#37;',
            ';': '&#59;',
            '(': '&#40;',
            ')': '&#41;',
            '+': '&#43;',
            '/': '&#47;',
            '¥': '&yen;',
            ',': '&#44;',
          }[match]
        });
    }
    
    render() {
        if (this.props.word === "") {
            return (
                <Helmet 
                title="記事の検索結果：朝日新聞"
                link={[{ rel: "canonical", href: "https://sitesearch.asahi.com/sitesearch/" }]}
            />
            )
        } else {
            let TITLE = `「${this.props.word}」のサイト内検索結果：朝日新聞`;
            let URL = encodeURI(`https://sitesearch.asahi.com/sitesearch/?Keywords=${this.props.word}&sort=${this.props.sort}&start=${this.props.start}`);
            let DESC = `朝日新聞社のニュースサイト、朝日新聞デジタルの${this.props.word}の検索結果のページです。`;
            let KEYWORDS = `朝日新聞デジタル,朝日新聞,ニュース,新聞,${this.props.word}の検索結果`;
            let WORDS = this.escapeWords(this.props.word);

            return (
                <Helmet>
                    <title>{TITLE}</title>
                    <meta name="description" content={DESC} />
                    <meta name="keywords" content={KEYWORDS} />
                    <link rel="canonical" href={URL} />
                    <script type="text/javascript">{`{ var sc_asa_digi_prop24 = "${WORDS}";}`}</script>
                </Helmet>
            )
        }
    }
}

Meta.propTypes = {
    word: PropTypes.string.isRequired,
    sort: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
}

export default Meta;